import request from '@/utils/request'

export default {
    getNotifications: async({ commit }, data) => {
        await request({
            method: 'get', url: '/notifications/system',
            params: {
                status: data.status,
                types: JSON.stringify(data.types)
            }
        }).then(res => {
            if (res.data) {
                commit('SET_NOTIFICATIONS', res.data)
            }
        })
    },

    getNotificationsHistory: async({ commit }, data) => {
        commit('SET_LOAD', true)
        await request({
            method: 'get', url: '/notifications/system', params: {
                ...Object.select(data, ['fromDate', 'toDate', 'page']),
                types: JSON.stringify(data.types),
                status: 'all'
            }
        }).then(res => {
            if (res.data && res.data.items) {
                commit('SET_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page
                })
                commit('SET_NOTIFICATIONS_HISTORY', res.data)
                commit('SET_LOAD', false)
            }
        })
    },

    readNotifications: async({ commit, dispatch }, data) => {
        await request({
            method: 'post', url: `/notifications/read`, data: data && data.ids ? {
                ids: data.ids
            } : {
                all: true
            }
        }).then(res => {
            dispatch('getNotifications', {
                types: [],
                status: 'unread'
            })
        })
    }
}
